module.exports = __webpack_public_path__ + "static/thy-6-71d48d24a10c8cf1f142d776124615d2.png";